var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedinLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.421 14H8.473C11.263 14 13 12 13 9.5C12.948 6.945 11.263 5 8.526 5C5.789 5 4 6.945 4 9.5C4 12 5.736 14 8.421 14ZM4 17H13V43H4V17ZM44 26.5C44 21.253 39.747 17 34.5 17C31.447 17 28.738 18.446 27 20.684V17H18V43H27V28C27 25.791 28.791 24 31 24C33.209 24 35 25.791 35 28V43H44C44 43 44 27.955 44 26.5Z",
    fill: "#0288D1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin-logo.be924b9d2a29a5a5c977dcdb883eaf35.svg";